export class Customer {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly email: string,
    public readonly phone: string,
    public readonly address: string,
    public readonly preferences: string = '',
    public readonly rating: number = 5.0,
    public readonly totalSpent: number = 0,
    public readonly lastService: string = '',
    public readonly createdAt: Date = new Date(),
    public readonly updatedAt: Date = new Date()
  ) {}

  static create(data: {
    name: string;
    email: string;
    phone: string;
    address: string;
    preferences?: string;
    rating?: number;
  }): Customer {
    return new Customer(
      crypto.randomUUID(),
      data.name,
      data.email,
      data.phone,
      data.address,
      data.preferences || '',
      data.rating || 5.0
    );
  }

  static fromPersistence(data: CustomerPersistenceData): Customer {
    return new Customer(
      data.id,
      data.name,
      data.email,
      data.phone,
      data.address,
      data.preferences || '',
      data.rating || 5.0,
      data.total_spent || 0,
      data.last_service || '',
      new Date(data.created_at),
      new Date(data.updated_at)
    );
  }

  toPersistence() {
    return {
      id: this.id,
      name: this.name,
      email: this.email,
      phone: this.phone,
      address: this.address,
      preferences: this.preferences,
      rating: this.rating,
      total_spent: this.totalSpent,
      last_service: this.lastService?.trim() ? this.lastService : null,
      created_at: this.createdAt.toISOString(),
      updated_at: this.updatedAt.toISOString()
    };
  }

  updateProfile(data: {
    name?: string;
    email?: string;
    phone?: string;
    address?: string;
    preferences?: string;
  }): Customer {
    return new Customer(
      this.id,
      data.name ?? this.name,
      data.email ?? this.email,
      data.phone ?? this.phone,
      data.address ?? this.address,
      data.preferences ?? this.preferences,
      this.rating,
      this.totalSpent,
      this.lastService,
      this.createdAt,
      new Date()
    );
  }

  addSpending(amount: number): Customer {
    return new Customer(
      this.id,
      this.name,
      this.email,
      this.phone,
      this.address,
      this.preferences,
      this.rating,
      this.totalSpent + amount,
      this.lastService,
      this.createdAt,
      new Date()
    );
  }
}

export interface CustomerPersistenceData {
  id: string;
  name: string;
  email: string;
  phone: string;
  address: string;
  preferences?: string;
  rating?: number;
  total_spent?: number;
  last_service?: string;
  created_at: string;
  updated_at: string;
}